import React from 'react';
import { ToolTip } from 'design-system';
const CreditsTooltip = () => (<ToolTip small title="Credits" subtitle="Credits are funds applied to your subscription invoice. They may come from referrals, gift cards, occasional bonuses from the Emma team, or as a pro-rata refund for unused time on your previous plan."/>);
export default CreditsTooltip;
